var _rect, _rect2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProposedcjeck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500326,
    y: 0.666662,
    width: 12.6667,
    height: 12.6667,
    rx: 6.33333,
    fill: "#F4F0FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.500326,
    y: 0.666662,
    width: 12.6667,
    height: 12.6667,
    rx: 6.33333,
    stroke: "#6F00FF",
    strokeWidth: 0.666667
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.83366,
    cy: 7,
    r: 2.66667,
    fill: "#6F00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposedcjeck);
export default __webpack_public_path__ + "static/media/proposedcjeck.19e58bd020296db1c7790195d3dcce51.svg";
export { ForwardRef as ReactComponent };